import Box from "@mui/material/Box";
import type { SxProps } from "@mui/material/styles";
import { FEATURE_DISPLAY_NAMES } from "@polifonia/interlude/billingConstants";
import type { BillingFeatureItem } from "@polifonia/interlude/models";
import type { muiTheme } from "@polifonia/theme";
import { theme } from "@polifonia/theme";

import { NumberFormat } from "@/components/NumberFormat";
import { Typography } from "@/components/Typography";

const styles = {
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 0",
    borderBottom: `1px solid ${theme.colors.neutral020}`,
    "&:last-child": {
      borderBottom: "none",
    },
  },
} satisfies Record<string, SxProps<typeof muiTheme>>;

interface FeaturePricingRowProps {
  item: BillingFeatureItem;
}

export const FeaturePricingRow: React.FC<FeaturePricingRowProps> =
  function FeaturePricingRow({ item }) {
    return (
      <Box sx={styles.root}>
        <Typography variant="body">
          {FEATURE_DISPLAY_NAMES[item.feature]}
        </Typography>
        <NumberFormat
          numberFormatPreset="currency"
          numberFormatLocale="en-US"
          numberFormatOptions={{
            currency: item.currency,
            currencyDisplay: "symbol",
          }}
          value={Number(item.unitAmount)}
        />
      </Box>
    );
  };
